import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';

const ProductionsInventory = () => {
  const [menu, setMenu] = useState(false);

  const [dataWeekly, setDataWeekly] = useState([]);
  const [permission, setPermission] = useState({});
   let season_id = localStorage.getItem("season_id");


  useEffect(() => {
        setPermission(FindModuleById(445)); 

        let para = {season_id:season_id};

  
  
 
      axios.post("/productions-inventories/auto_production_inventory",{},{ headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
      .then((response) => {
        //setData(response.data.data.inventories);
        if (response.data.code === 200) {
          axios.post("/productions-inventories/listing-new",para,{ headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
          .then((response) => {
            setDataWeekly(response.data.data.inventories);
            console.log(response);
          }).catch((error) => {
            console.log(error);
          });
        }
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });


    }, []);



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

 const calibreCell = ({ row }) => {
  console.log("row");
  console.log(row.original);
  const dateArr = row.original.week.split("_");
  console.log(dateArr); 
  let start_date = dateArr[0];
  let end_date = dateArr[1];

   return (
     <a href={`/productions-inventories-weekly?start_date=${start_date}&end_date=${end_date}&location=${row.original.location_id}`}>
       {start_date+ ' to '+end_date}
     </a>
   );
 };
  
 // ✅ PropTypes for calibreCell
 calibreCell.propTypes = {
   row: PropTypes.shape({
     original: PropTypes.shape({
      week_name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
     }).isRequired,
   }).isRequired,
 };
  
  
const columns_weekly = [
   {
      header: 'Week',
      accessorKey: 'week',

      Cell: calibreCell,
    },

 
  {
    accessorKey: 'total_raw_material_net_weight',
    header: 'Raw material Net Weight',
  },
  {
    accessorKey: 'total_bl_net_weight',
    header: 'BL Net Weight',
  },
  {
    accessorKey: 'decay_net_weight',
    header: 'Farm Decay Net Weight',
  },

  {
    accessorKey: 'weight_difference',
    header: 'Difference',
  },
  {
    accessorKey: 'total_consumpation',
    header: 'Total Consumpation',
  },
  {
    accessorKey: 'finished_products_net_weight',
    header: 'Finished product',
  },
  {
    accessorKey: 'decay_products_net_weight',
    header: 'Production Decay',
  },
  {
    accessorKey: 'return_products_net_weight',
    header: 'Return',
  },
  {
    accessorKey: 'reste_products_net_weight',
    header: 'Reste',
  },
  {
    accessorKey: 'losses',
    header: 'Losses',
  },
];

  
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Production Inventories</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Production Inventories</li>
                </ul>
              </div>
             
            </div>
          </div>


          <div className="row">
           
          <div className="col-md-12">
           <div className="card bg-white">
             
                <div className="card-body">
                  
               
                            <div className="table-responsive">
                            {permission && permission.list == 1 && (
                              <MaterialReactTable columns={columns_weekly} data={dataWeekly} 
                              enableColumnOrdering
                              // enableGrouping
                              enablePinning
                          
                            />
                            )}
                                   
                            </div>
                   
            
           </div>
           </div>
       </div>
     

            
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProductionsInventory;
